import axios, { AxiosResponse } from 'axios';

export const url = '/services/isnaportalsync/open-api/nds-payer/search-payer-data';

export const getTaxPayerInfo = (request: any, token?: any): Promise<AxiosResponse> => {
    return axios
        .get('/services/isnaportalsync/open-api/nds-payer/search-payer-data', {
            params: {
                taxpayerCode: request.iinBin,
            },
        })
        .then((response) => {
            const data = response.data;

            const tData = {
                ...data,
                beginDate: data.ndsRegistrationDate,
                endDate: data.ndsDeregistrationDate,
                reason: data.ndsDeregistrationReason?.ru || '',
            };

            return {
                ...response,
                data: tData,
            };
        });
};

export const checkCertificate = (request: any, token?: any): Promise<AxiosResponse> => {
    return axios
        .get(
            '/services/isnaportalsync/open-api/nds-payer/check-certificate-number-and-series-for-compliance',
            {
                params: {
                    taxpayerCode: request.iinBin,
                    number: request.number,
                    series: request.series,
                },
            }
        )
        .then((response) => {
            const data = response.data;

            const tData = {
                ...data,
                beginDate: data.responseData?.ndsRegistrationDate,
                endDate: data.responseData?.ndsDeregistrationDate,
                reason: data.responseData?.ndsDeregistrationReason?.ru || '',
                responseDate: data.responseDate,
                certificateInfo: {
                    ...data.certificateInfoData,
                    beginDate: data.certificateInfoData?.beginDate,
                },
                nameEn: data.responseData.nameEn,
                nameKz: data.responseData.nameKz,
                nameRu: data.responseData.nameRu,
            };

            return {
                ...response,
                data: {
                    iinBin: data.responseData?.iinBin,
                    name: data.responseData?.nameRu,
                    ...tData,
                },
            };
        });
};
